module.exports = "/images/eyeClose.svg";